import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { friendlyError } from '@/lib/errors/friendly';

type Props = {
  error: unknown;
  title?: string;
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
};

export function ErrorNotice({ error, title, onRetry, retryLabel = 'Try again', className }: Props) {
  const f = friendlyError(error, title);
  return (
    <div
      role="status"
      className={`rounded-md border border-border bg-muted/40 p-4 space-y-2 ${className ?? ''}`}
    >
      <div className="flex items-start gap-2">
        <AlertTriangle className="h-4 w-4 mt-0.5 text-muted-foreground shrink-0" />
        <div className="space-y-1">
          <p className="text-sm font-medium">{f.title}</p>
          <p className="text-sm text-muted-foreground">{f.description}</p>
        </div>
      </div>
      {onRetry && f.retryable && (
        <Button type="button" variant="outline" size="sm" onClick={onRetry}>
          <RefreshCw className="h-4 w-4 mr-2" />
          {retryLabel}
        </Button>
      )}
    </div>
  );
}
